import Seo from "@/components/Seo";
import { Reveal, MaskedLine } from "@/components/Reveal";
import { COMPANY } from "@/data/content";

const SECTIONS = [
  {
    title: "1. Information We Collect",
    body: [
      "When you submit our contact form, we collect the information you provide: your name, work email, company name, website/product URL, company size, testing requirements, current QA setup, and your message.",
      "We also collect standard technical information (such as browser type and pages visited) to understand how the website is used and to improve it.",
    ],
  },
  {
    title: "2. How We Use Your Information",
    body: [
      "We use the information you provide solely to respond to your enquiry, prepare for a consultation, and communicate with you about potential QA services.",
      "We do not sell, rent or share your personal information with third parties for their marketing purposes.",
    ],
  },
  {
    title: "3. Data Retention",
    body: [
      "Enquiry data is retained only as long as necessary to handle your request and any resulting business relationship. You may request deletion of your data at any time by contacting us.",
    ],
  },
  {
    title: "4. Cookies & Analytics",
    body: [
      "This website may use privacy-respecting analytics to understand aggregate usage patterns. [Describe specific analytics tooling here when configured.]",
    ],
  },
  {
    title: "5. Your Rights",
    body: [
      "You may request access to, correction of, or deletion of your personal data at any time by emailing us.",
    ],
  },
  {
    title: "6. Contact",
    body: [
      `For any privacy-related questions, contact us at ${COMPANY.email}.`,
    ],
  },
];

export default function Privacy() {
  return (
    <>
      <Seo
        title="Privacy Policy | Avirova Technologies"
        description="How Avirova Technologies collects, uses and protects information submitted through this website."
      />
      <section className="relative overflow-hidden pt-36 pb-16 lg:pt-44" data-testid="privacy-hero">
        <div className="grid-lines absolute inset-0" aria-hidden="true" />
        <div className="relative mx-auto max-w-7xl px-5 sm:px-8">
          <MaskedLine delay={0.1}>
            <p className="font-mono text-[11px] uppercase tracking-[0.3em] text-volt">{"// Legal"}</p>
          </MaskedLine>
          <h1 className="mt-6 font-display text-5xl font-black tracking-tighter text-zinc-100 sm:text-6xl">
            <MaskedLine delay={0.2}>Privacy Policy</MaskedLine>
          </h1>
          <MaskedLine delay={0.34}>
            <p className="mt-5 font-mono text-xs tracking-wide text-zinc-500">
              Effective date: [Effective Date] · Last updated: [Update Date]
            </p>
          </MaskedLine>
        </div>
      </section>
      <section className="mx-auto max-w-3xl px-5 pb-24 sm:px-8 lg:pb-32" data-testid="privacy-content">
        {SECTIONS.map((s) => (
          <Reveal key={s.title}>
            <div className="border-t border-zinc-800/80 py-10">
              <h2 className="font-display text-2xl font-bold tracking-tight text-zinc-100">{s.title}</h2>
              {s.body.map((p, i) => (
                <p key={i} className="mt-4 text-sm leading-relaxed text-zinc-400 sm:text-base">{p}</p>
              ))}
            </div>
          </Reveal>
        ))}
      </section>
    </>
  );
}
